import PropTypes from "prop-types";
import { memo } from "react";
import { components } from "react-select";

const DestinationInputValueFormat = props => {
	const { data } = props;

	return (
		<components.SingleValue {...props}>
			<div className="search-form__suggestion-label">{data.labels?.slice(-1).join(", ")}</div>
		</components.SingleValue>
	);
};

DestinationInputValueFormat.propTypes = {
	data: PropTypes.object,
};

export default memo(DestinationInputValueFormat);
